import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { count, countUnique, sum } from '@utils/summaries';
import { getMonthInfo } from '@utils/dates';
import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';

export const CutsByLocationLastMonth = () => {
    const { firstDay, lastDay } = getMonthInfo(1);

    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_LAST_MONTH,
        params: { startDate: firstDay, endDate: lastDay, range: 'monthly' },
    });

    return (
        <BaseReport
            title={'Total Successful Cuts by Location Last Month'}
            rangeText={styleDateRange([firstDay, lastDay])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Company Name', 'Reseller Name', 'Location Name', 'Successful Cuts', 'Rank'],
                data: data.map((item) => [item.companyName, item.resellerName, item.locationName, item.successfulCuts, item.rank]),
                summaries: [countUnique, countUnique, countUnique, sum, count],
                sort: [basicSort, basicSort, basicSort, basicSort, basicSort],
            }}
        />
    );
};
